import React from 'react';
import { BellIcon, CheckCircleIcon, AlertTriangleIcon, AlertCircleIcon, InfoIcon, XIcon } from 'lucide-react';
import { Alert } from '../../utils/dashboardData';
interface AlertsPanelProps {
  data: Alert[];
}
const AlertsPanel: React.FC<AlertsPanelProps> = ({
  data
}) => {
  const getAlertIcon = (type: string) => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon className="h-5 w-5 text-emerald-500" data-id="element-34" />;
      case 'warning':
        return <AlertTriangleIcon className="h-5 w-5 text-amber-500" data-id="element-35" />;
      case 'error':
        return <AlertCircleIcon className="h-5 w-5 text-red-500" data-id="element-36" />;
      case 'info':
        return <InfoIcon className="h-5 w-5 text-blue-500" data-id="element-37" />;
      default:
        return <BellIcon className="h-5 w-5 text-slate-500" data-id="element-38" />;
    }
  };
  const getAlertDotColor = (type: string) => {
    switch (type) {
      case 'success':
        return 'bg-emerald-500 border-emerald-200';
      case 'warning':
        return 'bg-amber-500 border-amber-200';
      case 'error':
        return 'bg-red-500 border-red-200';
      case 'info':
        return 'bg-blue-500 border-blue-200';
      default:
        return 'bg-slate-500 border-slate-200';
    }
  };
  const getAlertBg = (type: string) => {
    switch (type) {
      case 'success':
        return 'bg-emerald-50/50 border-emerald-100';
      case 'warning':
        return 'bg-amber-50/50 border-amber-100';
      case 'error':
        return 'bg-red-50/50 border-red-100';
      case 'info':
        return 'bg-blue-50/50 border-blue-100';
      default:
        return 'bg-slate-50/50 border-slate-100';
    }
  };
  return <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 h-full flex flex-col" data-id="element-39">
      <div className="flex items-center justify-between mb-6" data-id="element-40">
        <div className="flex items-center" data-id="element-41">
          <div className="p-2 bg-indigo-50 rounded-lg mr-3" data-id="element-42">
            <BellIcon className="h-5 w-5 text-indigo-600" data-id="element-43" />
          </div>
          <h2 className="text-lg font-bold text-slate-900" data-id="element-44">Notifications</h2>
        </div>
        <span className="bg-indigo-100 text-indigo-700 text-xs font-bold px-2.5 py-1 rounded-lg" data-id="element-45">
          {data.length} New
        </span>
      </div>

      <div className="flex-1 relative pl-4" data-id="element-46">
        {/* Timeline vertical line */}
        <div className="absolute left-[19px] top-4 bottom-4 w-px bg-slate-200" data-id="element-47"></div>

        <div className="space-y-5 relative" data-id="element-48">
          {data.map(alert => <div key={alert.id} className="relative pl-6 group" data-id="element-49">
              {/* Timeline dot */}
              <div className={`absolute left-[-5px] top-4 w-3 h-3 rounded-full border-2 z-10 ${getAlertDotColor(alert.type)}`} data-id="element-50"></div>

              <div className={`p-4 rounded-xl border ${getAlertBg(alert.type)} transition-all hover:shadow-md relative`} data-id="element-51">
                <button className="absolute top-3 right-3 text-slate-400 hover:text-slate-600 opacity-0 group-hover:opacity-100 transition-opacity bg-white/50 rounded-md p-1" data-id="element-52">
                  <XIcon className="h-3.5 w-3.5" data-id="element-53" />
                </button>
                <div className="flex items-start" data-id="element-54">
                  <div className="flex-shrink-0 mt-0.5 mr-3 bg-white p-1.5 rounded-lg shadow-sm" data-id="element-55">
                    {getAlertIcon(alert.type)}
                  </div>
                  <div data-id="element-56">
                    <h3 className="text-sm font-bold text-slate-900 mb-1 pr-6" data-id="element-57">
                      {alert.title}
                    </h3>
                    <p className="text-sm font-medium text-slate-600 mb-2 leading-relaxed" data-id="element-58">
                      {alert.message}
                    </p>
                    <span className="text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-59">
                      {alert.time}
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>

      <button className="w-full mt-6 py-2.5 border border-slate-200 rounded-xl text-sm font-bold text-indigo-600 hover:bg-indigo-50 transition-colors" data-id="element-60">
        Mark All as Read
      </button>
    </div>;
};
export default AlertsPanel;